<template>
  <div class="vue-edit-town-wrap">
    <div class="controls-container-wrapper">
      <div class="selected-town-container" v-if="selectedTown">
        <!-- name -->
        <div class="controls-container">
          <div class="control">
            <label for="utility">Name:</label>
            <input v-model="selectedTownForEdit.name" placeholder="Town name" type="text" class="name" v-bind:disabled="updatingTown">
          </div>
        </div>
        <!-- code -->
        <div class="controls-container">
          <div class="control">
            <label for="utility">Code:</label>
            <input v-model="selectedTownForEdit.code" placeholder="Town code" type="text" class="code" v-bind:disabled="updatingTown">
          </div>
        </div>
      <!-- county -->
      <div class="controls-container selected-utility">
        <div class="control utility-description">
          <label for="utility">County:</label>
          <select v-model="selectedTownForEdit.countyId" @change="onCountySelectChange($event)" name="utilites">
          <option v-for="county in counties" :key="county.countyId" :value="county.countyId">{{county.name}}</option>
          </select>
        </div>
      </div>
        <!-- synonym -->
        <div class="controls-container">
          <div class="control">
            <h4>Synonyms</h4>
            <ul class="synonyms">
              <li class="synonym">
                <input v-model="newTownAka.code" placeholder="Code" type="text" class="code" v-bind:disabled="updatingTown">
                <b-button
                v-if="!newTownAka.updating"
                @click="createTownAka(newTownAka)"
                class="add">Add Synonym</b-button>
                <b-spinner v-if="newTownAka.updating" class="ajax-spinner"></b-spinner>
                <span class="town-aka-error-message" v-if="newTownAka.errorMessage">{{newTownAka.errorMessage}}</span>
              </li>
              <li v-bind:class="{deleted: townAka.deleted}"  v-for="townAka in townAkas" :key="townAka.townAkaId" class="synonym">
                <div v-if="!townAka.deleted">
                  <input v-model="townAka.code" placeholder="Code" type="text" class="code" v-bind:disabled="updatingTown">
                  <b-button
                  v-if="!townAka.updating"
                  @click="updateTownAka(townAka)"
                  class="update">Update</b-button>
                  <b-button
                  class="delete"
                  v-if="!townAka.updating"
                  @click="deleteTownAka(townAka)">Delete</b-button>
                  <b-spinner v-if="townAka.updating" class="ajax-spinner"></b-spinner>
                  <span class="town-aka-error-message" v-if="townAka.errorMessage">{{townAka.errorMessage}}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="edit-town-footer">
      <b-spinner v-if="updatingTown" class="ajax-spinner"></b-spinner>
      <template>
        <b-button
        class="cancel"
        v-if="!updatingTown && !deleteMode"
        @click="cancel" v-bind:disabled="updatingTown">Cancel</b-button>
        <b-button
        class="update"
        v-if="!updatingTown && !deleteMode"
        @click="updateTown" v-bind:disabled="updatingTown">Update Town</b-button>
        <span
          class="delete-button-container"
          v-if="!updatingTown && (!townAkas || !townAkas.length)">
          <delete-button-with-confirm
          :deleteClicked="onDeleteButtonClicked"
          :cancelClicked="onDeleteCancelButtonClicked"
          :buttonText="'Delete ' + selectedTownForEdit.name"
          :confirmText="'Confirm delete: ' + selectedTownForEdit.name"
          :deleteConfirmClicked="onDeleteConfirmButtonClicked"></delete-button-with-confirm>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";
import lodash from 'lodash';
import DeleteButtonWithConfirm from "../../../../../shared/buttons/delete-button-with-confirm/DeleteButtonWithConfirm";

export default {
  name: 'EditTownForm',
  components: {
    DeleteButtonWithConfirm
  },
  props: {
    counties: Array,
    selectedTown: Object,
    getAllTowns: Function,
    destroySelectedTown: Function
  },
  async created() {
    this.updateSelectedTownForEdit(this.selectedTown);
    this.getTownAka();
  },
  watch: {
    selectedTown: function (selectedTown) {
      this.updateSelectedTownForEdit(selectedTown);
      this.getTownAka();
    }
  },
  data() {
    return {
      townAkas: [],
      deleteMode: false,
      updatingTown: false,
      selectedTownForEdit: {},
      newTownAka: {townId: this.selectedTown.townId}
    }
  },
  methods: {
      cancel() {
        this.destroySelectedTown();
      },
      onDeleteButtonClicked() {
        this.deleteMode = true;
      },
      onDeleteCancelButtonClicked() {
        this.deleteMode = false;
      },
      onDeleteConfirmButtonClicked() {
        this.deleteTown();
      },
      updateSelectedTownForEdit(selectedTown) {
        this .selectedTownForEdit = JSON.parse(JSON.stringify(selectedTown));
      },
      onCountySelectChange(event) {
        const matchinCounty = lodash.find(this.counties, county => county.countyId === parseInt(event.target.value));
        this.selectedCounty = matchinCounty ? matchinCounty : undefined;

        if (this.matchinCounty) {
          this.selectedTownForEdit.countyId = this.matchinCounty.countyId;
        }
      },
      deleteTown() {
        this.updatingTown = true;
        try {
          API.DeleteTown(this.selectedTown.townId).then(() => {
            this.updatingTown = false;
            this.$forceUpdate();
            this.destroySelectedTown();
            this.getAllTowns();
          }, err => {
            console.error('DeleteTown - ERROR');
            console.dir(err);
            this.$forceUpdate();
          })
        } catch (err) {
            this.updatingTown = false;
            console.error('DeleteTown - catch - ERROR');
            console.dir(err);
            this.$forceUpdate();
        }
      },
      createTownAka (newTownAka) {
        newTownAka.updating = true;
        this.$forceUpdate();
        const postData = JSON.parse(JSON.stringify(newTownAka));
        delete postData.updating;
        newTownAka.errorMessage = undefined;
        try {
          API.CreateTownAka(postData).then((addedTownAka) => {
            newTownAka.updating = false;
            this.$forceUpdate();
            this.townAkas.push(addedTownAka);
            this.newTownAka = {townId: this.selectedTown.townId};
          }, err => {
            console.error('createTownAka - ERROR');
            console.dir(err);
            newTownAka.updating = false;
            if (err && err.response && err.response.data) {
              newTownAka.errorMessage = err.response.data;
            } else {
              newTownAka.errorMessage = `Error updating ${newTownAka.code} synonym`;
            }
            this.$forceUpdate();
          })
        } catch (err) {
            this.updatingTown = false;
            console.error('createTownAka - catch - ERROR');
            console.dir(err);
            newTownAka.updating = false;
            this.$forceUpdate();
        }
      },
      updateTownAka (townAka) {
        townAka.updating = true;
        this.$forceUpdate();
        const postData = JSON.parse(JSON.stringify(townAka));
        townAka.errorMessage = undefined;
        delete postData.updating;
        try {
          API.UpdateTownAka(postData).then((newTownAka) => {
            console.warn('UpdateTownAka - SUCCESS');
            console.dir(newTownAka);
            townAka.updating = false;
            this.$forceUpdate();
            townAka = newTownAka;
          }, err => {
            console.error('UpdateTownAka - ERROR');
            console.dir(err);
            townAka.updating = false;
            if (err && err.response && err.response.data) {
              townAka.errorMessage = err.response.data;
            } else {
              townAka.errorMessage = `Error updating ${townAka.code} synonym`;
            }
            this.$forceUpdate();
          })
        } catch (err) {
            this.updatingTown = false;
            console.error('UpdateTownAka - catch - ERROR!');
            console.dir(err);
            townAka.updating = false;
            this.$forceUpdate();
        }
      },
      deleteTownAka (townAka) {
        townAka.updating = true;
        this.$forceUpdate();
        try {
          API.DeleteTownAka(townAka).then(() => {
            townAka.updating = false;
            this.$forceUpdate();
            townAka.deleted = true;
            this.getTownAka();
          }, err => {
            console.error('deleteTownAka - ERROR');
            console.dir(err);
            townAka.updating = false;
            this.$forceUpdate();
          })
        } catch (err) {
            this.updatingTown = false;
            console.error('deleteTownAka - catch  -ERROR');
            console.dir(err);
            townAka.updating = false;
            this.$forceUpdate();
        }
      },
      getTownAka() {
        try {
          API.GetTownAka(this.selectedTownForEdit.townId).then((townAkas) => {
            this.townAkas = JSON.parse(JSON.stringify(townAkas));
          }, err => {
            console.error('GetTownAka - ERROR');
            console.dir(err);
          })
        } catch (err) {
            this.updatingTown = false;
            console.error('GetTownAka - catch - ERROR');
            console.dir(err);
        }
      },
      updateTown() {
        this.updatingTown = true;

        try {
          API.UpdateTown(this.selectedTownForEdit).then(() => {
            this.updatingTown = false;
            this.getAllTowns();
            this.destroySelectedTown();
          }, err => {
            console.error('UpdateTown - ERROR');
            console.dir(err);
            this.updatingTown = false;
            if (err
            && err.response
            && err.response.data) {
              this.errorMessage = err.response.data;
            } else {
                this.errorMessage = `Error updating ${this.selectedTownForEdit.name}`;
            }
          })
        } catch (err) {
            this.updatingTown = false;
            console.error('updateTown - catch - ERROR');
            console.dir(err);
        }
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../../assets/css/partials/_variables.scss";

.ajax-spinner{
  position: relative;
  top: 14px;
  right: 10px;
  height: 40px;
  width: 40px;
  font-size: 22px;
  color: #fbd850;
}

.controls-container-wrapper{
  .selected-town-container{
    margin-top: 20px;

    .controls-container {
        width: 80%;
        margin-bottom: 20px;
        padding: 10px;
        background-color: $modalGrey;

        input[type="text"] {
          width: 100%;
          height: 40px;
          padding-left: 10px;
          border: none;
        }

        label {
          margin-right: 10px;
          font-weight: bold;
        }

        input[type="text"] {
          width: 100%;
        }

        h4{
          font-size: 18px;
          font-weight: bold;
        }

        .synonyms{
          .synonym{
            margin-bottom: 20px;
            padding: 5px 5px 5px 5px;
            background-color: $modalGrey;

              &.deleted{
                display: none;
              }

              input[type="text"] {
                width: 150px;
                margin-right: 10px;

                &.updating{
                  outline: 1px solid #fbd850;
                }
              }

            .ajax-spinner{
              left: 5px;
              top: 5px;
              height: 30px;
              width: 30px;
            }

            button {
              width: 70px;

              &.update{
                margin-right: 10px;
              }

              &.add{
                width: 150px;
              }
            }

            .town-aka-error-message{
              margin-left: 10px;
              color: #800000;
              font-weight: bold;
            }
          }
        }
      }
  }
}


.edit-town-footer{
  .btn{
    margin-right: 10px;

    &:last-child{
      margin-right: 0;
    }
  }
}
</style>
